import Vue from 'vue/dist/vue.esm'
export const eventBus = new Vue()